/*
 * ajax请求函数模块
 * 返回值：promise对象（异步返回的数据是：response.data）
 * */
import axios from "axios";
import router from '../router/index'
import commonJS from '../common/js/commonJS'
import envJS from '../common/js/env'
import qs from 'qs'

let Base64 = require('js-base64').Base64;
import {
	Toast
} from 'vant';

/**
 * 请求token
 * */
let encode = envJS.app_id + '|' + envJS.app_secret + '|2'
const reqTokenData = Base64.encode(encode) //供热传2，供水传3
export const REQTOKEN = params => {
	return axios.get('/api/token?data=' + params)
		.then(res => res.data);
};


// axios 配置
axios.defaults.timeout = 100000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.common['Authorization'] = commonJS.getCookie('Authorization');
axios.defaults.baseURL = envJS.baseUrl; //'http://180.76.57.168:8767';

let tokenResolve;
export const tokenReady = new Promise(resolve => { tokenResolve = resolve; });

const savedToken = commonJS.getCookie('Authorization');
if (savedToken) {
	tokenResolve();
}

REQTOKEN(reqTokenData).then(res => {
	if (res.code == 200) {
		console.log(res);
		commonJS.setCookie('Authorization', res.data.token);
		commonJS.setCookie('service_id', res.data.service_id);
		tokenResolve();
	} else {
		Toast.fail({
			message: res.msg,
			className: 'apiLoading'
		});
		tokenResolve();
	}
}).catch(error => {
	Toast.fail({
		message: '系统繁忙，请稍后重试！',
		className: 'apiLoading'
	});
	tokenResolve();
})

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading
let needLoadingRequestCount = 0 // 声明一个对象用于存储请求个数
function startLoading() {
	loading = Toast.loading({
		duration: 0, // 持续展示 toast
		forbidClick: true, // 禁用背景点击
		loadingType: 'spinner',
		message: '努力加载中...',
		className: 'apiLoading'
	});
}

function endLoading() {
	Toast.clear();
}

function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		startLoading()
	}
	needLoadingRequestCount++
}

function hideFullScreenLoading() {
	if (needLoadingRequestCount <= 0) return
	needLoadingRequestCount--
	if (needLoadingRequestCount === 0) {
		endLoading()
	}
}
//POST传参序列化 添加一个请求拦截器
axios.interceptors.request.use((config) => {
	let sc = commonJS.getCookie('service_id');
	console.log(config.headers['Content-Type'])
	//对供热状态变更接口不处理
	if(config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('multipart/form-data') > -1) {
		return config;
	}
	if (config.url != '/app/process/getRoomInfo' && config.url != '/app/process/saveProcessOrder' && config
		.url != '/app/process/getProcessOrderList' && config.url != '/app/process/getProcessOrderInfo' && config
		.url != '/app/process/code') {
		if (config.method === 'post') {
			let data = qs.parse(config.data)				
			
			config.data = qs.stringify({
				sc: sc,
				...data
			})
		}
		if (config.method === 'get') {
			config.params = {
				sc: sc,
				...config.params
			}
		}
		if (commonJS.getCookie('Authorization')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers.Authorization = commonJS.getCookie('Authorization');
		}
	}
	if (config.isLoading !== false) { // 如果配置了isLoading: false，则不显示loading
		showFullScreenLoading()
	}
	console.log(config.headers['Content-Type'])
	return config;
}, (error) => {
	hideFullScreenLoading()
	return Promise.reject(error);
});

//返回状态判断 添加一个响应拦截器
axios.interceptors.response.use(
	response => {
		if (response.data && response.data.code) {
			if (response.data.code === '2001') {

			}
		}
		hideFullScreenLoading() // 响应成功关闭loading
		return response;
	},
	error => {
		hideFullScreenLoading()
			console.log(error)
		if (error.response) {
			switch (error.response.data.status) {
				case 30006:
					//返回 30006 无效凭证
					router.push({
						name: 'login'
					})
			}
			//全局ajax错误信息提示
			// MessageBox({type:"error",message:error.response.data.msg,title:"温馨提示",});
		}
		return Promise.reject(error);
	});

export function fetch(url, config = {
	method: 'get'
}) {
	return axios.request({
		...config,
		url
	})
}

export default axios



// WEBPACK FOOTER //
// ./src/api/axios.js